import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2, Clock, XCircle } from "lucide-react";

const STATUS = {
  draft: {
    tone: "warn", icon: AlertTriangle,
    title: "Verify to accept USD payments",
    body: "Complete your KYB documents to activate your Flo USD collection account.",
    cta: "Start verification",
  },
  submitted: {
    tone: "info", icon: Clock,
    title: "Verification in progress",
    body: "Xflow is reviewing your KYB submission. This typically takes 1–2 business days.",
    cta: "View submission",
  },
  additional_info_requested: {
    tone: "warn", icon: AlertTriangle,
    title: "Xflow needs additional documents",
    body: "Please review the requested documents and upload them to continue.",
    cta: "Provide documents",
  },
  rejected: {
    tone: "error", icon: XCircle,
    title: "Verification failed",
    body: "Your KYB submission was not accepted. Review the details and re-submit.",
    cta: "Fix and re-submit",
  },
  activated: null, // no banner when active
};

const TONES = {
  warn:  "bg-[#FFF4E1] border-[#F5B840] text-[#7A5000]",
  info:  "bg-[#EAF2FF] border-[#1E5BD6] text-[#0A1F44]",
  error: "bg-[#FDECEC] border-[#D2453B] text-[#7A1A15]",
};

export default function KybStatusBanner({ status }) {
  const cfg = STATUS[status];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <div
      role="status"
      data-testid={`kyb-banner-${status}`}
      className={`flex items-start gap-3 rounded-xl border px-4 py-3 mb-6 ${TONES[cfg.tone]}`}
    >
      <Icon className="h-5 w-5 shrink-0 mt-0.5" />
      <div className="flex-1">
        <div className="font-semibold text-sm">{cfg.title}</div>
        <div className="text-sm opacity-90 mt-0.5">{cfg.body}</div>
      </div>
      <Link
        to="/kyb"
        data-testid="kyb-banner-cta"
        className="shrink-0 self-center px-4 py-2 rounded-lg bg-[#1E5BD6] text-white text-sm font-semibold hover:opacity-90"
      >
        {cfg.cta}
      </Link>
    </div>
  );
}
